export default __webpack_public_path__ + "static/media/gd_5.26c1a279.jpg";